export default "__VITE_ASSET__JuuqCR9Q__"